var agent = navigator.userAgent;
if(
  agent.indexOf('iPhone') !== -1 ||
  agent.indexOf('iPod') !== -1 ||
  agent.indexOf('iPad') !== -1 ||
  agent.indexOf('Android') !== -1
) {
  $('html').addClass('isSP');
}
